export const ShiftHttpPaths = {
  shift: (id: string) => `/shifts/${id}`,
  issueTypes: '/issues',
  cancelShift: (id: number) => `/shifts/${id}/cancel`,
  workerLate: (id: number) => `/shifts/${id}/worker-late`,
  workerArrived: (id: number) => `/shifts/${id}/worker-late-arrival`,
  pulloutShift: (id: string) => `/shifts/${id}/pullouts`,
} as const;
